<template>
  <div class="brandActivity">
    <template v-if="!isIndex">
      <ActivityStyle
        :showData="item"
        :showIndex="index"
        v-for="(item, index) in brandActivity"
        :key="item.id"
      />
    </template>
    <template v-else>
      <WapActivityStyle
        :showData="item"
        :showIndex="index"
        v-for="(item, index) in brandActivity"
        :key="item.id"
      />
    </template>
  </div>
</template>
<script>
import ActivityStyle from "../components/activityStyle.vue";
import WapActivityStyle from "../components/wapActivityStyle.vue";
export default {
  name: "brandActivity",
  components: {
    ActivityStyle,
    WapActivityStyle,
  },
  data() {
    return {
      isIndex: false,
      brandActivity: [],
      lan: this.$store.state.isEn,
      articleTypeId: 9,
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
  },
  mounted() {
    this.init();
  },
  created () {
      // 获取当前屏幕宽度
    let screenWidth = window.innerWidth || document.documentElement.clientWidth;
    if (screenWidth < 961) {
      this.isIndex = true
    }
    // 创建一个媒体查询，检查屏幕的宽度是否大于或等于 961px
    this.mediaQuery = window.matchMedia("(min-width: 961px)");
    // 添加事件侦听器，在状态更改时收到通知
    this.mediaQuery.addListener(this.handleMediaQueryChange);
  },
  beforeDestroy() {
    this.mediaQuery.removeListener(this.handleMediaQueryChange);
  },
  methods: {
    handleMediaQueryChange(event) {
      this.isIndex = !event.matches;
    },
    async init() {
      await this.$api.get(
        "/activity/list",
        { current: 1, pageSize: 10, activityType: 6 },
        (r) => {
          const { data = {}, code } = r;
          if (code == 0) {
            if (data && data.length > 0) {
              data.forEach((el) => {
                // 合并重复的逻辑分支
                el.showImg = el.image && JSON.parse(el.image);
              });
            }
            this.brandActivity = data;
          }
        }
      );
    },
  },
};
</script>
<style scoped>
.brandActivity {
  margin: 134px auto 60px;
  width: 1400px;
  display: flex;
  flex-wrap: wrap;
}
@media (max-width: 1440px) {
  .brandActivity {
    margin: 114px auto 30px;
    width: 100%;
  }
}
@media (max-width: 960px) {
  .brandActivity {
    margin: 120px auto 30px;
    width: 100%;
    display: block;
  }
}

/* 平板设备适配 */
@media (min-width: 768px) and (max-width: 960px) {
  .brandActivity {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
}

/* 移动设备适配 */
@media (max-width: 767px) {
  .brandActivity {
    margin: 100px auto 20px;
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
  }
}
</style>